import React from "react";
import { Button } from "antd";
import { useGlobal } from "App/Hooks/global/GlobalContext";
import { Row } from "core/util-styled-components";

const buttonPropsDefault = {
  type: "primary",
  shape: "circle",
  size: "small",
};

const ButtonBars = ({ buttonProps = buttonPropsDefault }) => {
  const { barraActiva, setBarraActiva } = useGlobal();
  return (
    <Button {...buttonProps} onClick={() => setBarraActiva(!barraActiva)}>
      <Row alignItems="center" justifyContent="center">
        <i className="fa fa-bars" />
      </Row>
    </Button>
  );
};

export default ButtonBars;
